import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const postPatientList = async (listName, sharedWith) => {
  const apiURL = API_HOST + '/patient_lists';
  const { token, userID } = useCurrentUser();

  // console.log('saving ');
  try {
    const { data } = await axios.post(
      apiURL,
      {
        patient_list: {
          list_name: listName,
          shared_with: sharedWith,
        },
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
          'x-dqpn-user-id': userID,
        },
      },
    );
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
